import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";
import React, { useEffect } from "react";
import ModalInfoGEG from "./modal_info_geg.tsx";
import { ModalLinkBEG, ModalLinkGEG } from "../components/modal_link.tsx";
import GEGInfo from "../components/geg_info.tsx";
import { round_to_1000 } from "../functions.ts";

export default function ModalKellerFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);

       const keller_future = useStore((state)=>state.keller_future);    
        const api_get_costs = useStore((state)=>state.api_get_costs);
        useEffect(()=>{
            api_get_costs("floor_insulation",keller_future);
        },[keller_future]);
    
  return (<Panel >
            <h1>Wie soll die Kellerdecke gedämmt werden?</h1>
            <GEGInfo GEG={0.3} BEG={0.25}/>
            <PropertyInput type="keller_future"/>
            <PropertyInput type="keller_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["floor_insulation"].total_costs)  + " €"}/>
            <PropertyInput type="keller_isfp"/>

            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                close_menu();
                init_property_if_undefined("keller_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

